import { Component, OnInit, OnChanges, Input } from "@angular/core";
import { DevicesService } from "../../../devices/devices.service";
import { HistoricVar, QueryReadings } from "../../../devices/device.model";
import { Constants } from "../../../../shared/constants";
import { DatePipe } from "@angular/common";
import { EnergyService } from "../../energy.service";
import { SharedUtils } from "../../../../shared/shared.utils";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { Device } from "../../../devices/devices.model_new";
import { GROUP } from "../../../devices/devices.constant";
import { HOUSE_TARIFF } from "../../../houses/houses.constants";

@Component({
  selector: "app-consumption-resume",
  templateUrl: "./consumption-resume.component.html",
  styleUrls: ["./consumption-resume.component.scss"],
})
export class ConsumptionResumeComponent implements OnInit {
  @Input() consumptionSubType: String;
  @Input() gasMeterId: String;
  SharedUtils = SharedUtils;
  sourceIds: Map<string, HistoricVar>;
  mode: string;
  activeView = "day";
  selectionSeconds = "86400";
  integrationPeriodType = "0";
  selectedDate: string;
  customEnd: Date;
  currentSelectedDate = new Date(Date.now());
  public selectedMoments;
  totalConsumption: number;
  public numberOfTariffs = 1;
  totalConsumptionNormal = 0;
  totalConsumptionEconomic = 0;
  totalConsumptionSuperEconomic = 0;
  smartReaderDevice: Device;
  nextMode: any;
  isBi = false;
  isTri = false;

  constructor(
    private devicesService: DevicesService,
    private datePipe: DatePipe,
    private energyService: EnergyService,
    private sessionStateService: SessionStateService
  ) {}

  ngOnInit() {
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        if (this.energyService.isMicroGeneration()) {
          this.smartReaderDevice = this.findConsumptionMeter(smartMeter);
        } else {
          this.smartReaderDevice = smartMeter[0];
        }
      });

    if (this.sessionStateService.getHouseTariff().tariff === HOUSE_TARIFF.BI) {
      this.isBi = true;
    } else if (
      this.sessionStateService.getHouseTariff().tariff === HOUSE_TARIFF.TRI
    ) {
      this.isTri = true;
    }
  }

  getRespectiveEndDate(): Date {
    if (!this.selectedMoments) {
      if (this.activeView === "day" || this.activeView === "minute") {
        return new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate() + 1
        );
      }
      if (this.activeView === "month") {
        return new Date(
          this.currentSelectedDate.getFullYear(),
          this.currentSelectedDate.getMonth() + 1,
          this.currentSelectedDate.getDate()
        );
      }
      if (this.activeView === "year") {
        return new Date(
          this.currentSelectedDate.getFullYear() + 1,
          this.currentSelectedDate.getMonth(),
          this.currentSelectedDate.getDate()
        );
      }
    } else {
      if (this.selectedMoments[1] !== null) {
        return new Date(
          this.selectedMoments[1].getFullYear(),
          this.selectedMoments[1].getMonth(),
          this.selectedMoments[1].getDate() + 1
        );
      } else {
        return new Date(
          this.selectedMoments[0].getFullYear(),
          this.selectedMoments[0].getMonth(),
          this.selectedMoments[0].getDate() + 1
        );
      }
    }
  }

  changeMode(event) {
    this.mode = "";
    this.nextMode = event;
    const modeUpdate = setInterval(() => {
      this.mode = event;
      clearInterval(modeUpdate);
    }, 500);
  }

  totalsUpdate(event) {
    this.totalConsumptionNormal = 0;
    this.totalConsumptionEconomic = 0;
    this.totalConsumptionSuperEconomic = 0;
    if (event[0] === "consumption") {
      if (this.nextMode === "Eur") {
        this.totalConsumptionNormal =
          event[1] && event[1].cost.N ? event[1].cost.N : 0;
        this.totalConsumptionEconomic +=
          event[1] && event[1].cost.E ? event[1].cost.E : 0;
        this.totalConsumptionSuperEconomic +=
          event[1] && event[1].cost.SE ? event[1].cost.SE : 0;
      } else {
        this.totalConsumptionNormal =
          event[1] && event[1].value.N ? event[1].value.N : 0;
        this.totalConsumptionEconomic +=
          event[1] && event[1].value.E ? event[1].value.E : 0;
        this.totalConsumptionSuperEconomic +=
          event[1] && event[1].value.SE ? event[1].value.SE : 0;
      }
    }
    this.totalConsumption =
      this.totalConsumptionNormal +
      this.totalConsumptionEconomic +
      this.totalConsumptionSuperEconomic;
  }

  findConsumptionMeter(meters: Device[]) {
    let consumptionMeter: Device = meters[0];
    meters.forEach((meter) => {
      if (meter.getGroups().has(GROUP.CONSUMPTION_METER)) {
        consumptionMeter = meter;
      }
    });
    return consumptionMeter;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-resume/consumption-resume/consumption-resume.component.ts